var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('header',[_vm._v("About Us")]),_c('p',[_vm._v(" Welcome to Haba, Haba is a place for your creativity and expression. It’s also a global community of people looking for a fun, welcoming experience. ")])])
}]

export { render, staticRenderFns }